import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as httpClient from "../../util/httpClient";
import * as LoginActions from "../../store/loginService/actions";
import { useForm } from "react-hook-form";
import ReCAPTCHA from "react-google-recaptcha";
import * as ConfigurationActions from "../../store/configurationService/actions";
import * as ProtectionPlanActions from "../../store/protectionPlanService/ezs/actions";
import * as Service from "../../store/service";
import { EnrollNowPath } from "../../util/enrollPath";
import * as MyAccountActions from "../../store/myAccount/actions";
import { GetAccountInformation } from "../../store/service";
import CommerceBankLoginOption from "../Login/CommerceBankLoginOption";
import ErrorBoundary from "../common/ErrorBoundary";
import i18nService from "../../util/Internationalization/i18n/i18n";
import { GetServiceDetails } from "../../store/common";
import { isCommerceBankPartner } from "../../util/partner";
import { PATTERNS } from "../../util/patterns";
import { RECEIVE_CONFIGURATION } from "../../store/configurationService/types";
import { Trans, useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { staticURLs } from "../../config/urls";

const Login = (props: any) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const history = useHistory();

    useEffect(() => {
        if (footerLogoHTML) {
            const domParser = new DOMParser();
            const parsedDoc = domParser.parseFromString(footerLogoHTML, "text/html");
            let imgElement = parsedDoc.querySelectorAll("img");
            for (let i = 0; i < imgElement.length; i++) {
                imgElement[i].setAttribute("alt", "Logo");
                footerLogoHTML = parsedDoc.documentElement.innerHTML;
            }
            setLogoHTML(footerLogoHTML);
        }
    }, []);

    const [isLoader, setIsLoader] = useState(false);
    const [state, setState] = useState({
        loginId: "",
        password: "",
        captchaValue: "",
        showCaptcha: false,
        showErrorMessage: false,
        errorMsg: "login.validationMessage.invalidEmailOrPassword",
        isChecked: false,
        isLoading: false,
        isLockedout: false,
    });
    const [logoHTML, setLogoHTML] = useState("");

    let footerLogoHTML: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerProvider
            ? state.configurationState.configuration.partnerConfig.footerLogoHTML
            : ""
    );
    const [showPasswordField, setShowPasswordField] = useState(false);
    const defaultLoginDescription: string = tLang("login.message");
    const [loginMsg, setLoginMsg] = useState(defaultLoginDescription);
    const [type, setType] = useState("");
    const [globalOfferCode, setGlobalOfferCode] = useState("");
    const { isFailedVerification } = ((props.location && props.location.state) as any) || ({} as any);
    const query = new URLSearchParams(props.location.search);
    let email: any = query.get("Email");
    email = email?.includes(" ") ? email.replace(/\s/g, "+") : email;

    const { register, errors, handleSubmit, reset, trigger, setValue } = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
        defaultValues: {
            loginId: email ? email : localStorage.rememberMeEmail,
            password: null,
        },
    });
    useEffect(() => {
        setLoginMsg(defaultLoginDescription);
    }, [defaultLoginDescription]);
    const dispatch = useDispatch();
    const requestRecaptchaSiteKey = () => dispatch(ConfigurationActions.actionCreators.requestRecaptchaSiteKey());
    const requestIDFLoginURL = () => dispatch(ConfigurationActions.actionCreators.requestIDFLoginURL());
    const requesPartnerConfig = () => dispatch(ConfigurationActions.actionCreators.requestPartnerConfig());
    const partnerID: number = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId
            : 0
    );
    const isIDFPartner: boolean = useSelector((state: ApplicationState) =>
            state.configurationState && state.configurationState.configuration.partnerConfig.isIdfPartner
                ? state.configurationState.configuration.partnerConfig.isIdfPartner
                : false
        );
    const checkContractChange = (operation: string, globalOfferCode: string) =>
        dispatch(ProtectionPlanActions.actionCreators.checkContractChange(operation, globalOfferCode));
    const setLoginFromUrl = (fromRedirectUrl: boolean) => dispatch(ProtectionPlanActions.actionCreators.setLoginFromUrl(fromRedirectUrl));
    const siteKey = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration ? state.configurationState.configuration.recaptchaSiteKey : ""
    );

    const bookmarkLogin: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration ? state.configurationState.configuration.partnerConfig.bookmarkLoginText : ""
    );
    const isEnrollmentAvailable = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isEnrollmentAvailable
            ? state.configurationState.configuration.partnerConfig.isEnrollmentAvailable
            : false
    );
    const isWalkupEnrollAvailable = useSelector(
        (state: ApplicationState) => state.configurationState && state.configurationState.configuration.partnerConfig.isWalkupEnrollAvailable
    );
    const partnerLegalName = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.enrollNowPath
            ? state.configurationState.configuration.partnerConfig.legalName
            : ""
    );
    const idfLoginURL = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration && state.configurationState.configuration.idfLoginURL
            ? state.configurationState.configuration.idfLoginURL
            : ""
    );
    const enrollNowPathURL = EnrollNowPath();
    let captcha: any;
    const partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    const brandingLogo: string = useSelector((state: ApplicationState) =>
        state.configurationState &&
            state.configurationState.configuration.partnerConfig.brandingOption &&
            state.configurationState.configuration.partnerConfig.brandingOption.imagePath
            ? state.configurationState.configuration.partnerConfig.brandingOption.imagePath
            : ""
    );
    const supportInternational = useSelector(
        (state: ApplicationState) =>
            state.configurationState &&
            state.configurationState.configuration &&
            state.configurationState.configuration.partnerConfig &&
            state.configurationState.configuration.partnerConfig.supportInternational
    );
    const requestProtectionPlan = (forcefullyRefresh: boolean) => dispatch(ProtectionPlanActions.actionCreators.requestProtectionPlan(forcefullyRefresh));
    const isLife360PartnerId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 539
                ? true
                : false
            : false
    );
    const isAvastId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2611
                ? true
                : false
            : false
    );

    const isBitdefenderId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2569
                ? true
                : false
            : false
    );

    const isAVGId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2659
                ? true
                : false
            : false
    );
    const isAVGTestId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2662
                ? true
                : false
            : false
    );

    const isTowerFcuId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2657
                ? false //TODO - replace with true after testing
                : false
            : false
    );

    const isHancockWhitneyPartner = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2603
                ? true
                : false
            : false
    );

    const appStateConfiguration = useSelector((state: ApplicationState) => state.configurationState && state.configurationState.configuration);
    const allowLoginWithUserName: boolean = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.allowLoginWithUserName
            ? state.configurationState.configuration.partnerConfig.allowLoginWithUserName
            : false
    );
    const fromLogout = props.history && props.history.location.state ? props.history.location.state.from : "";
    const accountInfo: any = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));
    const SetPreferencedLanguage = (leng: any, updateUsersLang: boolean) => dispatch(LoginActions.actionCreators.SetPreferencedLanguage(leng, updateUsersLang));
    const [isRedirect, setIsRedirect] = useState(false);

    const isOneTrustPartner = useSelector((state: ApplicationState) => {
        const partnerId = state.configurationState?.configuration?.partnerConfig?.partnerId;
        return partnerId != null && [2649, 1557].includes(partnerId);
    });

    const allowChangePassword = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig?.ssoOptions?.allowChangePassword
    );

    const forcePasswordResetForSSOUser = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig?.ssoOptions?.forcePasswordResetForSSOUser
    );

    useEffect(() => {
        dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
    }, [dispatch, routeLoading]);

    useEffect(() => {
        if (isOneTrustPartner) {
            var CookiePrefFooterLink = document.getElementById("cookie-pref-footer-link");
            if (CookiePrefFooterLink != null) {
                CookiePrefFooterLink.remove();
            }
            var cookiePrefIcon = document.getElementById('onetrust-consent-sdk');
            if (cookiePrefIcon != null) {
                cookiePrefIcon.hidden = true;
            }
        }
    }, []);

    const openSsoLogin = () => {
        window.open(staticURLs.SsoUrl, "_self");
    };

    const setCountry = () => {
        if (supportInternational) {
            if (!!!accountInfo) {
                GetAccountInformation().then((data: any) => {
                    const country = data?.["_unifiedAccountInfo"]?.country;
                    if (data?.["_unifiedAccountInfo"]?.["_languagePreference"]?.code) {
                        const userPreferedLanguage = data["_unifiedAccountInfo"]["_languagePreference"].code.toLowerCase();
                        if (!!userPreferedLanguage) {
                            SetPreferencedLanguage(userPreferedLanguage, false);
                        }
                    }
                    if (!!country) {
                        // only set state if we have data (setCountry function called once before login and again after login)
                        dispatch(MyAccountActions.actionCreators.getAccountInformation(false, data));
                        i18nService.setRegionBasedonCountry(country);
                    } else {
                        i18nService.setRegionBasedonCountry("US");
                    }
                });
            } else {
                const country = accountInfo["_unifiedAccountInfo"] != null ? accountInfo["_unifiedAccountInfo"]?.country : accountInfo.country;
                if (!!country) {
                    i18nService.setRegionBasedonCountry(country);
                } else {
                    i18nService.setRegionBasedonCountry("US");
                }
            }
        } else {
            i18nService.setRegionBasedonCountry("US");
        }
    };

    const captchaOnChange = (value: any) => {
        setState({ ...state, captchaValue: value });
    };

    const logout = () => {
        setIsLoader(false);
        Service.isUserAuthenticated().then((data) => {
            if (data && data.isUserAuthenticated && !isFailedVerification) {
                let ssoFlag;
                if (allowChangePassword && forcePasswordResetForSSOUser) {
                    GetAccountInformation().then((data: any) => {
                        if (data["_unifiedAccountInfo"] && data["_unifiedAccountInfo"]._personalAccountInformation.primaryEmail) {
                            dispatch(MyAccountActions.actionCreators.getAccountInformation(false, data));
                        }
                        if (data["_unifiedAccountInfo"] && data["_unifiedAccountInfo"].isSSOUser) {
                            ssoFlag = data["_unifiedAccountInfo"].isSSOUser;
                        }
                        if (ssoFlag) {
                            props.history.push({
                                pathname: "/change-password",
                            });
                        }
                        else {
                            props.history.push({
                                pathname: "/dashboard",
                            });
                        }
                    });
                }
                else {
                    props.history.push({
                        pathname: "/dashboard",
                    });
                }
            } else {
                props.history.push({
                    pathname: "/Login",
                    state: { isFailedVerification: isFailedVerification },
                });
                dispatch({ type: "USER_LOGGED_OUT" });
            }
        });
    };

    const performCancellationContinuation = () => {
        if (type.toUpperCase() === "CONT") {
            checkContractChange("cancelletionContinuation", globalOfferCode);
        } else {
            checkContractChange("contractChange", "");
        }
    };

    const showCancellationContinuationText = (query: any) => {
        const loginType = query.get("Type") || query.get("TYPE") || query.get("type");
        const offerCode = query.get("ID") || query.get("Id") || query.get("id");
        if (loginType && loginType.toUpperCase() === "CONT") {
            setLoginMsg("Login to renew your subscription.");
            setLoginFromUrl(true);
        } else {
            setLoginMsg(defaultLoginDescription);
            setLoginFromUrl(false);
        }
        setType(loginType == null ? "" : loginType);
        setGlobalOfferCode(offerCode == null ? "" : offerCode);
    };

    useEffect(() => {
        setIsLoader(true);

        if (!fromLogout) {
            ssoLogin();
            requestRecaptchaSiteKey();
            requesPartnerConfig();
            requestIDFLoginURL();
        }

        window.addToDataLayer({ event: "Submit Partner Name", current_partner_name: partnerLegalName });

        if (localStorage.rememberMeEmail && localStorage.remeberMeEmail !== "") {
            setState({ ...state, isChecked: true });
        }
        const contType = query.get("Type") || query.get("TYPE") || query.get("type");
        const redirectMessage = query.get("RedirectMessage");
        const prefixKey = query.get("prefixKey");
        if (prefixKey) {
            const requestBody = { prefixKey: prefixKey };
            httpClient.sendRequest("POST", "/app/api/validator/IsActivationLinkExpired", requestBody).then((data: any) => {
                if (!data.isActivationLinkValid) {
                    history.push("/link-expiry", { linkMessage: "Your activation link is no longer valid." });
                    return;
                }
            });
        }

        if (email) {
            setState({
                ...state,
                loginId: email,
            });
            setShowPasswordField(true);
            setIsLoader(false);
            return;
        }
        if (contType) {
            showCancellationContinuationText(query);
            setIsLoader(false)
            return;
        }
        if (redirectMessage) {
            setState({ ...state, showErrorMessage: true, errorMsg: redirectMessage, isLoading: false });
            setIsLoader(false)
            return;
        }
        logout();
    }, []);

    useEffect(() => {
        setCountry();
    }, [supportInternational === true]);

    const resetCaptcha = () => {
        if (captcha != null) {
            captcha.reset();
            setState({ ...state, captchaValue: "" });
        }
    };

    const onSubmit = (data: any) => {
        setState({ ...state, isLoading: true });
        onSubmitLogin(data);
    };

    const redirectSSO = (email: string) => {
        setIsRedirect(true);
        Service.getAuthenticationType({ email })
            .then((res) => {
                if (res.userAuthStatus !== "SSO") {
                    setIsRedirect(false);
                }
                // SSO User
                // dispatch({
                //     type: RECEIVE_CONFIGURATION,
                //     configuration: {
                //         ...appStateConfiguration,
                //         userAuthStatus: res.userAuthStatus
                //     }
                // });

                dispatch(ConfigurationActions.actionCreators.setUserAuthStatus(res.userAuthStatus));

                if (res.userAuthStatus === "SSO") {
                    window.location.replace(
                        `/${res.ssoRedirectURL}?brand=sontiq&supportPhone=${partnerPhoneNumber}&email=${encodeURIComponent(email)}&logo=${encodeURIComponent(
                            brandingLogo
                        )}`
                    );
                }
            })
            .catch((err) => {
                setIsRedirect(false);
            });
    };

    const checkEmail = (loginData: any) => {
        setState({ ...state, isLoading: true });
        const email = loginData.loginId;
        const requestBody = { email };

        Service.getIDFUserDetails(requestBody)
            .then((data) => {
                setState({ ...state, isLoading: false });
                if (data && data.errorNumber) {
                    if (data.errorNumber === 300) {
                        if (idfLoginURL) {
                            window.open(idfLoginURL + "?Email=" + encodeURIComponent(email), "_self");
                        } else {
                            setShowPasswordField(true);
                        }
                    } else {
                        setShowPasswordField(true);
                    }
                } else {
                    setShowPasswordField(true);
                }
            })
            .catch((error) => {
                setState({ ...state, isLoading: false });
                setShowPasswordField(true);
            });
        if (email) {
            redirectSSO(email);
        }
    };
    const ssoLogin = () => {
        setState({ ...state, isLoading: true, loginId: email ? email : "" });
        GetAccountInformation().then((data: any) => {
            if (data["_unifiedAccountInfo"] && data["_unifiedAccountInfo"]._personalAccountInformation.primaryEmail) {
                dispatch(MyAccountActions.actionCreators.getAccountInformation(false, data));
            }
            if (data["_unifiedAccountInfo"] && data["_unifiedAccountInfo"].isSSOUser) {
                const isSSOUser = data["_unifiedAccountInfo"].isSSOUser;
                const requestBody = {
                    EmailAddress: "test@gmail.com",
                    Password: "Password@123",
                    CaptchaValue: "11111",
                };
                if (!!accountInfo && accountInfo.email !== "" && data["_unifiedAccountInfo"].email !== accountInfo.email) {
                    dispatch({ type: "USER_LOGGED_OUT" });
                }
                httpClient.sendRequest("POST", "web/login/UserLogin", requestBody).then((body) => {
                    body.EmailAddress = body.emailAddress;
                    dispatch(LoginActions.actionCreators.submitLogin(body, props.history, isSSOUser));
                    GetServiceDetails(dispatch);
                    requestProtectionPlan(true);
                    setCountry();
                    dispatch(ConfigurationActions.actionCreators.requestCountryList(isIDFPartner,partnerID));
                    setState({ ...state, isLoading: false });
                });
            } else {
                const query = new URLSearchParams(props.location.search);
                const redirectMessage = query.get("RedirectMessage");
                if (redirectMessage) {
                    setState({ ...state, showErrorMessage: true, errorMsg: redirectMessage });
                    return;
                } else {
                    setState({ ...state, isLoading: false, loginId: email ? email : "" });
                }
            }
        });
    };
    useEffect(() => {
        if (email) {
            redirectSSO(email);
        }
    }, [email]);

    const setUsersPreferedLanguage = () => {
        if (!!!accountInfo) {
            GetAccountInformation().then((data: any) => {
                if (data["_unifiedAccountInfo"] && data["_unifiedAccountInfo"]._personalAccountInformation.primaryEmail) {
                    dispatch(MyAccountActions.actionCreators.getAccountInformation(false, data));
                    const userPreferedLanguage =
                        data["_unifiedAccountInfo"] &&
                            data["_unifiedAccountInfo"]["_languagePreference"] &&
                            !!data["_unifiedAccountInfo"]["_languagePreference"].code
                            ? data["_unifiedAccountInfo"]["_languagePreference"].code.toLowerCase()
                            : "";
                    if (!!userPreferedLanguage) {
                        SetPreferencedLanguage(userPreferedLanguage, false);
                    }
                }
            });
        } else {
            const userPreferedLanguage =
                accountInfo &&
                accountInfo["_unifiedAccountInfo"] &&
                accountInfo["_unifiedAccountInfo"]["_languagePreference"] &&
                accountInfo["_unifiedAccountInfo"]["_languagePreference"];
            if (!!userPreferedLanguage) {
                SetPreferencedLanguage(userPreferedLanguage["code"], false);
            }
        }
    };
    const onSubmitLogin = (loginData: any) => {
        const requestBody = {
            EmailAddress: loginData.loginId,
            Password: loginData.password,
            CaptchaValue: state.captchaValue,
        };
        httpClient
            .sendRequest("POST", "web/login/UserLogin", requestBody)
            .then((data) => {
                if (data.isValidUser) {
                    if (data.partnerSiteRedirectionRequired) {
                        window.location.href = data.partnerURL;
                        return;
                    } else {
                        if (state.isChecked) {
                            localStorage.rememberMeEmail = loginData.loginId;
                        }
                        if (!state.isChecked && localStorage.rememberMeEmail) {
                            localStorage.removeItem("rememberMeEmail");
                        }
                        if (data.reCompleteRegistration) {
                            props.history.push("/recomplete-registration");
                            return;
                        }
                        data.EmailAddress = data.emailAddress;
                        performCancellationContinuation();
                        setUsersPreferedLanguage();
                        setCountry();
                        dispatch(LoginActions.actionCreators.submitLogin(data, props.history, false));
                        dispatch(MyAccountActions.actionCreators.getSecurityQuestions());
                        dispatch(ConfigurationActions.actionCreators.requestCountryList(isIDFPartner,partnerID));
                    }
                } else {
                    setValue("password", null);
                    trigger();
                    let msg = allowLoginWithUserName
                        ? "Incorrect email/username or password entered, please try again."
                        : "login.validationMessage.invalidEmailOrPassword";
                    setState({ ...state, showCaptcha: false, showErrorMessage: false, isLoading: false, password: "" });
                    if (data.accountLockedout) {
                        setState({ ...state, isLockedout: true, showCaptcha: true, errorMsg: msg, showErrorMessage: true, isLoading: false, password: "" });
                    } else {
                        if (data.showCaptcha) {
                            msg = allowLoginWithUserName ? "Incorrect email/username or password entered." : "login.validationMessage.invalidEmailOrPassword";
                            setState({ ...state, showCaptcha: true, showErrorMessage: true, errorMsg: msg, isLoading: false, password: "" });
                            resetCaptcha();
                        } else {
                            setState({ ...state, showErrorMessage: true, isLoading: false, errorMsg: msg, password: "" });
                        }
                    }
                }
            })
            .catch(function (error) {
                reset();
                trigger();
                resetCaptcha();
                setState({ ...state, showErrorMessage: true, errorMsg: tLang("login.validationMessage.somethingWentWrong"), isLoading: false, password: "" });
            });
    };

    const handleInputChange = (event: any) => {
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;

        if (name === "loginId") {
            setShowPasswordField(false);
            setState({
                ...state,
                showErrorMessage: false,
                [name]: value,
            });
        } else if (name === "password") {
            setState({
                ...state,
                [name]: value,
                showErrorMessage: false,
            });
        } else {
            setState({
                ...state,
                [name]: value,
            });
        }
    };

    const hasReCAPTCHAError = () => {
        if (state.showCaptcha && !state.captchaValue && showPasswordField) {
            return true;
        }
        return false;
    };

    const getLoginDescription = () => {
        const isDefaultLoginDescription: boolean = loginMsg === defaultLoginDescription;
        const loginDescription = isCommerceBankPartner(partnerID) && isDefaultLoginDescription ? tLang("login.commerceBankLoginDesc") : loginMsg;
        return loginDescription;
    };

    const emaitLabel: string = isCommerceBankPartner(partnerID)
        ? tLang("login.ezshieldUserLabel")
        : allowLoginWithUserName
            ? tLang("login.userIdLabel")
            : `${tLang("login.labels.email")} `;


    return (
        <React.Fragment>
            {isLoader ?
            <div className="box box-has-shadow box-xs no-padding loading">
            </div>
            :
            <div is="x3d" id="l-page-content">
                <div className="l-page-container">
                    <div className=" row">
                        <div className="col-xs-12">
                            <h1 className="title-page sr-only" id="title-page" tabIndex={-1}>
                                Member Login
                            </h1>
                        </div>
                    </div>
                    <div className="row margin-vertical-xl margin-update" id="content">
                        <div className="col-xs">
                            {state.isLockedout && (
                                <div className="notice-container status-warning notice-xs" role="alert" aria-atomic="true">
                                    <span role="img" aria-label="info-circle" className="notice-icon">
                                        <em className="las la-exclamation-circle"></em>
                                    </span>
                                    <div className="notice-message">{tLang("login.accountLockedMessage")}</div>
                                    <div className="notice-description">
                                        {tLang("login.disabledMessagePart1")} <a href={'tel:"' + partnerPhoneNumber + '"'}>{partnerPhoneNumber}</a>.{" "}
                                        {tLang("login.disabledMessagePart2")}
                                    </div>
                                </div>
                            )}

                            {isFailedVerification && (
                                <div className="notice-container status-warning notice-xs" role="alert" aria-atomic="true">
                                    <span role="img" aria-label="info-circle" className="notice-icon">
                                        <em className="las la-exclamation-circle"></em>
                                    </span>
                                    <div className="notice-message">{tLang("login.verificationFailed")}</div>
                                    <div className="notice-description">{tLang("login.varificationFailedTryAgain")}</div>
                                </div>
                            )}

                            {bookmarkLogin ? (
                                <div className="box box-has-shadow box-xs less-padding" style={{ marginBottom: "15px" }}>
                                    <span>
                                        <ExclamationCircleFilled className="ant-exclamation" /> <Trans>{bookmarkLogin}</Trans>
                                    </span>
                                </div>
                            ) : (
                                ""
                            )}

                            {isHancockWhitneyPartner ? (
                                <div
                                    className={
                                        state.isLoading || isRedirect ? "box box-has-shadow box-xs no-padding loading" : "box box-has-shadow box-xs no-padding"
                                    }
                                >
                                    <div className="box-header">
                                        <div
                                            style={{ textAlign: "center", padding: "25px" }}
                                        >
                                            <h3>{tLang("login.hancockWhitneyPartnerMsg")}</h3>
                                            <div style={{ marginTop: "5px" }}>
                                                <span>
                                                    <a href="https://apps.apple.com/app/id6567574582" target="_blank" rel="noopener noreferrer">
                                                        <img src="https://cdn.ezshield.net/images/_Shared/_Logos/ApplePlayStore.png" width="110" height="38" alt="Apple App Store" border="1" />
                                                    </a>
                                                </span>
                                                <span >
                                                    <a href="https://play.google.com/store/apps/details?id=com.hancockwhitney.mobilepersonal" target="_blank" rel="noopener noreferrer">
                                                        <img src="https://cdn.ezshield.net/images/_Shared/_Logos/GooglePlayStoreLogo.png" width="110" height="40" alt="Google Play Store" border="1" />
                                                    </a>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div
                                    className={
                                        state.isLoading || isRedirect
                                            ? "box box-has-shadow box-xs offset-padding loading"
                                            : "box box-has-shadow box-xs offset-padding"
                                    }
                                >
                                    <div className="box-header">
                                        <div className="box-title-container">
                                            <div className="box-title-icon" aria-hidden="true">
                                                <em className="las la-lock"></em>
                                            </div>
                                            <div className="box-title-text">
                                                <h2 className="box-title">
                                                    {isAvastId || isAVGId || isAVGTestId || isBitdefenderId ? "Sign in to the dashboard" : tLang("login.title")}
                                                </h2>
                                            </div>
                                        </div>
                                        <ErrorBoundary componentName="Commerce Bank Login Option" type="hideError" replaceDefaultContent={false} errorMsg="">
                                            <CommerceBankLoginOption />
                                        </ErrorBoundary>

                                        {!isTowerFcuId && (
                                            <div className="box-description">
                                                {isAvastId || isAVGId || isAVGTestId || isBitdefenderId ? (
                                                    <p className="avast-text">
                                                        <strong>Have you received an invitation from your family organizer? </strong>
                                                        Sign in with your email
                                                    </p>
                                                ) : (
                                                    <p>{getLoginDescription()}</p>
                                                )}
                                            </div>
                                        )}
                                    </div>

                                    {!isTowerFcuId && (
                                        <div className="box-content">
                                            <form id="form-member-login" onSubmit={showPasswordField ? handleSubmit(onSubmit) : handleSubmit(checkEmail)}>
                                                <div className="form-row">
                                                    <div className="form-label">
                                                        {!(isAvastId || isAVGId || isAVGTestId || isBitdefenderId) ? (
                                                            <label htmlFor="email">
                                                                {emaitLabel}
                                                                <span className="required" title="Mandatory">
                                                                    *
                                                                </span>
                                                            </label>
                                                        ) : (
                                                            <label htmlFor="email" className="hide-label">
                                                                Email
                                                            </label>
                                                        )}
                                                    </div>
                                                    <div className="form-input">
                                                        <input
                                                            aria-required="true"
                                                            type="text"
                                                            id="email"
                                                            className={
                                                                errors.loginId &&
                                                                    (!state.loginId || state.loginId.length > 100 || errors.loginId.type === "pattern")
                                                                    ? "status-error inputbox"
                                                                    : "inputbox"
                                                            }
                                                            name="loginId"
                                                            ref={register({
                                                                required: true,
                                                                maxLength: 100,
                                                                pattern: allowLoginWithUserName ? PATTERNS.USERNAME_OR_EMAIL.pattern : PATTERNS.EMAIL.pattern,
                                                            })}
                                                            defaultValue={state.loginId}
                                                            onChange={handleInputChange}
                                                            maxLength={100}
                                                            placeholder={isAvastId || isAVGId || isAVGTestId || isBitdefenderId ? "Email" : ""}
                                                        />
                                                    </div>
                                                    {errors.loginId && (errors.loginId.type === "maxLength" || state.loginId.length > 100) && (
                                                        <div className="form-row">
                                                            <div role="alert" className="col-xs-12 col-no-gutter">
                                                                {allowLoginWithUserName ? (
                                                                    <span className="required">{tLang("login.usernameMaxLen")}</span>
                                                                ) : (
                                                                    <span className="required">{tLang("login.emailMaxLen")}</span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}
                                                    {errors.loginId && errors.loginId.type === "required" && !state.loginId && (
                                                        <div className="form-row">
                                                            <div role="alert" className="col-xs-12 col-no-gutter">
                                                                {allowLoginWithUserName ? (
                                                                    <span className="required">{tLang("login.userNameRequired")}</span>
                                                                ) : (
                                                                    <span className="required">{tLang("login.validationMessage.email.required")}</span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}
                                                    {errors.loginId && errors.loginId.type === "pattern" && (
                                                        <div className="form-row">
                                                            <div role="alert" className="col-xs-12 col-no-gutter">
                                                                {allowLoginWithUserName ? (
                                                                    <span className="required">{tLang("login.userNamePattern")}</span>
                                                                ) : (
                                                                    <span className="required">{tLang("login.validationMessage.email.pattern")}</span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                {showPasswordField && (
                                                    <div className="form-row">
                                                        <div className="form-label">
                                                            <label htmlFor="password-label">
                                                                {tLang("login.labels.password")}{" "}
                                                                <span className="required" title="Mandatory">
                                                                    *
                                                                </span>
                                                            </label>
                                                        </div>
                                                        <div className="form-input">
                                                            <input
                                                                aria-required="true"
                                                                autoComplete="off"
                                                                type="password"
                                                                className={
                                                                    errors.password && !state.showErrorMessage && (!state.password || state.password.length > 64)
                                                                        ? "status-error inputbox"
                                                                        : "inputbox"
                                                                }
                                                                id="password-label"
                                                                defaultValue={state.password}
                                                                onChange={handleInputChange}
                                                                name="password"
                                                                ref={register({ required: true, maxLength: 64 })}
                                                            />
                                                        </div>
                                                        {errors.password &&
                                                            !state.showErrorMessage &&
                                                            (errors.password.type === "maxLength" || state.password.length > 64) && (
                                                                <div className="form-row">
                                                                    <div role="alert" className="col-xs-12 col-no-gutter">
                                                                        <span className="required">{tLang("login.passwordMaxLength")}</span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        {errors.password && errors.password.type === "required" && !state.showErrorMessage && (
                                                            <div className="form-row">
                                                                <div role="alert" className="col-xs-12 col-no-gutter">
                                                                    <span className="required">{tLang("login.validationMessage.password.required")}</span>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}

                                                <div className="form-row">
                                                    <div className="form-input">
                                                        <label className="form-checkbox-label" htmlFor="remember_me">
                                                            <input
                                                                type="checkbox"
                                                                name="isChecked"
                                                                id="remember_me"
                                                                onChange={handleInputChange}
                                                                checked={state.isChecked}
                                                            />
                                                            <span className="form-checkbox-label-text">{tLang("login.labels.rememberCheckbox")}</span>
                                                        </label>
                                                    </div>
                                                </div>

                                                {state.showCaptcha && siteKey !== "" && showPasswordField && (
                                                    <div className="form-row row">
                                                        <div className="col-xs-12 col-no-gutter">
                                                            <div className="form-input">
                                                                <ReCAPTCHA
                                                                    sitekey={siteKey}
                                                                    onChange={captchaOnChange}
                                                                    ref={(el) => {
                                                                        captcha = el;
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                <div className={"form-row " + (isAvastId || isAVGId || isAVGTestId || isBitdefenderId) ? "avast-btn" : ""}>
                                                    <button
                                                        type="submit"
                                                        className={
                                                            isCommerceBankPartner(partnerID)
                                                                ? "btn-login-green btn-default btn-primary btn-min-width"
                                                                : "btn-default btn-primary btn-min-width"
                                                        }
                                                        onClick={() => {
                                                            isAvastId ||
                                                                isAVGId ||
                                                                isAVGTestId ||
                                                                isBitdefenderId ||
                                                                (showPasswordField && window.addToDataLayer({ event: "Login Button" }));
                                                        }}
                                                    >
                                                        <span className="btn-text">
                                                            {isAvastId || isAVGId || isAVGTestId || isBitdefenderId
                                                                ? "SIGN IN WITH EMAIL"
                                                                : showPasswordField
                                                                    ? tLang("login.login-btn")
                                                                    : tLang("login.continueButtonText")}
                                                        </span>
                                                    </button>
                                                </div>

                                                {state.showErrorMessage && (
                                                    <div className="form-row">
                                                        <div role="alert" className="col-no-gutter" style={{ maxWidth: "100%" }}>
                                                            <span className="required">
                                                                {state.errorMsg === "login.validationMessage.invalidEmailOrPassword"
                                                                    ? tLang("login.validationMessage.invalidEmailOrPassword")
                                                                    : state.errorMsg}
                                                            </span>
                                                        </div>
                                                    </div>
                                                )}

                                                <div className="margin-bottom-m"></div>

                                                {hasReCAPTCHAError() && (
                                                    <div className="form-row">
                                                        <div role="alert" className="col-no-gutter" style={{ maxWidth: "100%" }}>
                                                            <span className="required">{tLang("login.validationMessage.tryWithRecaptcha")}</span>
                                                        </div>
                                                    </div>
                                                )}

                                                <div className="form-row">
                                                    <button
                                                        type="button"
                                                        className="btn-default btn-link btn-no-padding btn-no-border"
                                                        onClick={() => {
                                                            window.addToDataLayer({ event: "Forgot my password" });
                                                            props.history.push("/forgot-password");
                                                        }}
                                                    >
                                                        <span className="btn-text">{tLang("login.forgonMyPasswordLinkText")}</span>
                                                    </button>
                                                </div>

                                                {isEnrollmentAvailable && isWalkupEnrollAvailable && (
                                                    <React.Fragment>
                                                        <div className="line-divider margin-vertical-l"></div>
                                                        <h2 className="content-sub-title">{tLang("login.notAMember")}</h2>
                                                        <p>
                                                            {tLang("login.notAMemberLink")}
                                                            <a
                                                                href={enrollNowPathURL}
                                                                className="default_link"
                                                                onClick={() => window.addToDataLayer({ event: "Enroll Now" })}
                                                            >
                                                                {tLang("login.enrollNow")}
                                                            </a>
                                                        </p>
                                                        {(partnerID !== 513) &&  <>
                                                            <div className="box-description wyntk-description">
                                                                <p>
                                                                    {tLang("login.whatYouNeedToKnowContent1")} <strong>{tLang("login.vantageScoreModel")}</strong>
                                                                    {". "}
                                                                    {tLang("login.whatYouNeedToKnowContent2")}
                                                                </p>
                                                            </div>
                                                        </>}
                                                    </React.Fragment>
                                                )}
                                            </form>
                                        </div>
                                    )}
                                </div>
                            )}

                            {isLife360PartnerId && (
                                <div className="box box box-has-shadow box-xs " style={{ marginTop: "25px" }}>
                                    <p>{tLang("login.noticeForLife360")}</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="logo-container" dangerouslySetInnerHTML={{ __html: logoHTML }}></div>
            </div>
            }
        </React.Fragment>
    );
};

export default Login;
